import { Head } from '@inertiajs/react'
import CommandCenterLayout from '@/frontend/layouts/CommandCenterLayout'
import ConnectionSetup from '@/frontend/features/LocalMcp/ConnectionSetup'
import CredentialsPanel from '@/frontend/features/LocalMcp/CredentialsPanel'
import type { LocalMcpProps } from '@/frontend/features/LocalMcp/types'

function McpAccessesPage(props: LocalMcpProps) {
  return <>
    <Head title={props.page_title} />
    <div className="mx-auto w-full max-w-5xl space-y-7">
      <header>
        <h1 className="text-2xl font-semibold tracking-tight">{props.copy.title}</h1>
        <p className="mt-2 text-sm text-muted-foreground">{props.copy.description}</p>
      </header>
      {props.guide && <ConnectionSetup key={props.issued_token} guide={props.guide} copy={props.copy} />}
      <CredentialsPanel {...props} />
      <details className="border-t border-border pt-4 text-xs text-muted-foreground">
        <summary className="w-fit cursor-pointer hover:text-foreground">{props.copy.help}</summary>
        <div className="mt-3 flex flex-wrap gap-x-5 gap-y-3">
          <a href="https://developers.openai.com/codex/mcp/" target="_blank" rel="noreferrer" className="hover:underline">Codex</a>
          <a href="https://code.claude.com/docs/en/mcp" target="_blank" rel="noreferrer" className="hover:underline">Claude Code</a>
          {props.skills.map((skill) => <a key={skill.slug} href={`/cc/mcp_accesses/skills/${skill.slug}`} className="hover:underline">{props.copy.download} · {skill.slug}</a>)}
        </div>
      </details>
    </div>
  </>
}
McpAccessesPage.layout = (page: React.ReactElement) => <CommandCenterLayout>{page}</CommandCenterLayout>
export default McpAccessesPage
